import {ICmSearchPageFields} from "../../../types/FmsTypes";
import {Options} from "@/components2/YhFormBox/Types";

//搜索参数
export interface IServiceItemsParams {
    sourceApp?: string,
    branch?: string,
    code?: string,
    status?: string
}

//列表参数
export interface IServiceItemsDetail {
    "note"?: string,
    "ver"?: number,
    "code"?: string,
    "enable"?: number,
    "name"?: string,
    "branch"?: string,
    "key"?: string,
    "workHours": number,
    "price": number,
    "amount"?: number,
    itemBrand?: string
    recommendCommodity?: string
    recommendStatus?: string
    itemAttr?: string
    itemClassificationId?: string
    itemClassificationName?: string
}

//新增参数S
export interface IServiceItemsInsert {
    "sourceApp"?: string,
    "note"?: string,
    "ver"?: number,
    "code"?: string,
    "enable"?: number | boolean,
    "name"?: string,
    "branch"?: string,
    "workHours": number,
    "price": number,
    "amount"?: number,
    itemBrand?: string
    recommendCommodity?: string
    recommendStatus?: string
    itemAttr?: string
    itemClassificationId?: string
    itemClassificationName?: string
}

//修改参数
export interface IServiceItemsUpdata {
    "sourceApp"?: string,
    "note"?: string,
    "ver"?: number,
    "code"?: string,
    "enable"?: number,
    "name"?: string,
    "branch"?: string,
    "key"?: string,
    "workHours"?: number,
    "price": number,
    "amount"?: number,
    itemBrand?: string
    recommendCommodity?: string
    recommendStatus?: string
    itemAttr?: string
    itemClassificationId?: string
    itemClassificationName?: string
}

//禁用接口
export interface IServiceItemsDisable {
    "sourceApp": string,
    "branch": string,
    "code": string
}

export interface IServiceItemsSearch extends IServiceItemsParams, ICmSearchPageFields {

}

export const itemAttrOptions: Options[] = [
    {label: "进口", key: "import", value: "import"},
    {label: "国产", key: "domestic", value: "domestic"}
]


/**
 * 各门店价格
 */
export interface IServiceItemsShopPriceParams {
    "sourceApp"?: string,

    // 门店信息 展示用
    shopInfo?: string

    shopId?: string

    // 门店编码
    code?: string

    name?: string
    itemCode?: string
    itemName?: string
    itemWorkHours?: number,
    workHoursPrice?: number,
    itemAmount?: number,
    enable?: number
    status?: boolean
    note?: string
}


export interface IServiceItemShopPriceDetail {
    branch: string
    "sourceApp"?: string,

    // 门店编码
    code?: string
    // 门店名称
    name?: string

    itemCode?: string

    itemName?: string
    itemWorkHours?: number,
    workHoursPrice?: number,
    itemAmount?: number,
    status?: number
    enable?: number
    note?:string
}
